import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import MfprintingtypeEditForm from './MfprintingtypeEditForm';
import MfprintingtypeList from './MfprintingtypeList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import MfprintingtypeListView from './MfprintingtypeListView'


export default function MfprintingtypeDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.mfprintingtypeDashboard);
  const [ mfprintingtypeId, setMfprintingtypeId] = React.useState('');
  const [reloadMfprintingtypeList, setReloadMfprintingtypeList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <MfprintingtypeEditForm 
            setReloadMfprintingtypeList={setReloadMfprintingtypeList}
            mfprintingtypeId={mfprintingtypeId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <MfprintingtypeListView 
                      setMfprintingtypeId = {setMfprintingtypeId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
